/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-10-17 10:04:09
 * @FilePath: /vue_huaqiang/src/router/modules/report-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {RouteConfig} from "vue-router";
import Layout from "@/layout/index.vue";

const closingPositionManagement: RouteConfig[] = [
    {
        path: "/closingPositionManagement",
        component: Layout,
        redirect: "closingPositionManagement",
        name: "closingPositionManagement",
        meta: {
            title: "closingPositionManagement",
            icon: "el-icon-s-goods",
            alwaysShow: true
        },
        children: [
          { // 平仓管理
            path: "/closingPositionManagementInfo",
            name: "closingPositionManagementInfo",
            component: () =>
              import("@/views-oms/closing-position/closingPositionManagementInfo.vue"),
            meta: { title: "closingPositionManagementInfo" }
          },
          { // 审核平仓单
            path: "/reviewClosingOrders",
            name: "reviewClosingOrders",
            component: () =>
              import("@/views-oms/closing-position/reviewClosingOrders.vue"),
            meta: { title: "reviewClosingOrders" }
          },
          { // 客人在库
            path: "/guestsInStock",
            name: "guestsInStock",
            component: () =>
              import("@/views-oms/closing-position/guestsInStock.vue"),
            meta: { title: "guestsInStock" }
          },
          { // 平仓单详情
            path: "/closingPositionDetail",
            name: "closingPositionDetail",
            component: () =>
              import("@/views-oms/closing-position/closingPositionDetail.vue"),
            meta: { title: "closingPositionDetail",hidden: true }
          },
        ]
    }
];

export default closingPositionManagement;
